import React from 'react';

const Code2SVG = ({ color = '#011211', className, ...props }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='13'
      viewBox='0 0 16 13'
      fill='none'
      className={className}
      {...props}
    >
      <path
        d='M5.84612 6.39258L1 12.2079'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.84612 6.39253L1 0.577148'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M15.0001 12.4233H6.38477'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default Code2SVG;
